export default "/static/media/icon-checkmark.3a0e3a71.svg";